import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { UserDeleteMenuItem } from './UserDeleteMenuItem';
import { UserEditMenuItem } from './UserEditMenuItem';
import { UserReinviteMenuItem } from './UserReinviteMenuItem';
import { UserResetMfaMenuItem } from './UserResetMfaMenuItem';

interface Props extends ChakraV3.ButtonProps {
  user: User;
}

export const UserActionMenu = (props: Props) => {
  const { user, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <UserEditMenuItem user={user} />
          <UserReinviteMenuItem user={user} />
          <UserResetMfaMenuItem user={user} />
          <UserDeleteMenuItem user={user} />
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger>
        <ChakraV3.Button variant='outline' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
